// Loaded as its own asset rather than via {% javascript %}: the compiled section
// bundle currently fails to parse, which silently kills every section script.
// The bar only becomes visible when this runs, so in the bundle it never showed.
function initStickyCart(scope) {
  // Any bar that reveals on scroll opts in with data-sticky-reveal, so the
  // sticky cart block and the sticky Sticky bar share one implementation.
  (scope || document).querySelectorAll('[data-sticky-reveal]').forEach(function (bar) {
    if (bar.dataset.ready) return;
    bar.dataset.ready = 'true';

    var trigger = parseInt(bar.getAttribute('data-trigger'), 10);
    if (isNaN(trigger)) trigger = 800;

    // Each bar carries a real submit control, so nothing is forwarded by hand.
    // The old handler looked for a '.sticky-cart-btn' and a
    // '[data-product-form]' that do not exist in this theme.
    var frame = null;
    var sync = function () {
      frame = null;
      bar.classList.toggle('visible', window.scrollY > trigger);
    };

    window.addEventListener(
      'scroll',
      function () {
        if (frame) return;
        frame = requestAnimationFrame(sync);
      },
      { passive: true }
    );

    sync();
  });
}

// Pinned bars ([data-sticky-pin] slot around the bar) sit in the page first and
// lock under the header once their slot scrolls up to it. The slot keeps the
// bar's height while it is fixed, so the content below never jumps.
function initStickyPin(scope) {
  (scope || document).querySelectorAll('[data-sticky-pin]').forEach(function (slot) {
    if (slot.dataset.ready) return;
    slot.dataset.ready = 'true';
    var bar = slot.firstElementChild;
    if (!bar) return;

    var frame = null;
    var headerOffset = function () {
      return parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
    };
    var sync = function () {
      frame = null;
      var pinned = slot.getBoundingClientRect().top <= headerOffset();
      if (pinned === bar.classList.contains('is-pinned')) return;
      slot.style.minHeight = pinned ? bar.offsetHeight + 'px' : '';
      bar.classList.toggle('is-pinned', pinned);
    };
    var schedule = function () {
      if (frame) return;
      frame = requestAnimationFrame(sync);
    };

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', function () {
      if (bar.classList.contains('is-pinned')) slot.style.minHeight = bar.offsetHeight + 'px';
      schedule();
    });
    sync();
  });
}

initStickyCart();
initStickyPin();
document.addEventListener('shopify:section:load', function (event) {
  initStickyCart(event.target);
  initStickyPin(event.target);
});
